<div class="drawer-item-wrap">
    <div [id]="'nav-' + entity().id" class="drawer-item" [class.active]="isActive()" (click)="selectEntity()">
        <div class="drawer-item-content">
            <small
                class="sp-icon icon-chevron-right"
                style="display: block"
                [style.rotate]="showChildren() ? '90deg' : '0deg'"
            >
            </small>

            <img src="./assets/img/websites/lpc-icon-row.svg" alt="lpc-row-icon" />

            <div class="text-wrapper">
                <div class="text-item">{{ "row" | translate }}</div>
                <div class="id-item" [title]="'id: ' + displayId()">id: {{ displayId() }}</div>
            </div>
        </div>
    </div>
    <div dropdown #dropdown="bs-dropdown" class="btn-group dropdown dropdown-options">
        <button
            dropdownToggle
            type="button"
            class="btn btn-action dropdown-toggle"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span class="sp-icon icon-ellipsis"></span>
        </button>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
            <li
                role="menuitem"
                [class.disabled]="isDeleteDisabled() || isSectionRestricted()"
                (click)="removeSection()"
            >
                <a>
                    <span class="sp-icon icon-bin color-danger"></span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>

@if (showChildren()) {
    <div class="drawer-item-children">
        @for (column of columns(); track $index) {
            <web-navigation-column-item
                [entity]="column"
                [parentEntity]="entity()"
                [parentIndex]="index()"
                [selectedEntity]="selectedEntity()"
                [isSpecific]="true"
            />
        }
    </div>
}
